import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageContext from "../../context/LanguageContext.js";
import "./breadcrumb.css";

const Breadcrumb = ({ page, title }) => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();
    const location = useLocation();

    const allPaths = location.pathname.split("/").filter(Boolean);

    const localeKeys = ["en", "ar", "tr", "fa", "ru", "el"];
    const currentLanguage = allPaths.find((segment) => localeKeys.includes(segment)) || "en";

    const paths = allPaths.filter((segment) => !localeKeys.includes(segment));

    const toCamelCase = (str) => {
        return str.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
    };

    const translateSegment = (segment) => t(`breadcrumb.${toCamelCase(segment)}`, segment.charAt(0).toUpperCase() + segment.slice(1));

    const pageTitle = title || page || (paths.length > 0 ? translateSegment(paths[paths.length - 1]) : t("breadcrumb.home", "Home"));
    const homePath = `/${currentLanguage}`;

    return (
        <div className="breadcrumb-container" dir={dir()}>
            <h1 className="breadcrumb-title">{pageTitle}</h1>

            <nav className="breadcrumb">
                <ul>
                    <li>
                        <Link to={homePath}>
                            {t("breadcrumb.home", "Home")}
                        </Link>
                    </li>

                    {paths.map((segment, index) => {
                        const routeTo = `${homePath}/${paths.slice(0, index + 1).join("/")}`;
                        const isLast = index === paths.length - 1;
                        const label = translateSegment(segment);

                        return (
                            <li key={index}>
                                <span className="separator">/</span>
                                {isLast ? (
                                    <span className="current">{label}</span>
                                ) : (
                                    <Link to={routeTo}>{label}</Link>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    );
};

export default Breadcrumb;
